export default __webpack_public_path__ + "static/media/c_logo.910c48f5.svg";